export default {
  /////////////////
  // ModerationAll
  /////////////////

  SET_MODERATATION_ALL_EMISSION(state, value) {
    state.moderationAll = value
  },
  ADD_MODERATATION_ALL_EMISSION(state, value) {
    state.moderationAll.push(value)
  },
  EDIT_MODERATATION_ALL_EMISSION(state, value) {
    const userIndex = state.moderationAll.findIndex((u) => u.id === value.id)
    state.moderationAll.splice(userIndex, 1, value)
  },
  ////////////////////////////////////////////////////////
}
